import { createAction } from "@reduxjs/toolkit";

export const addPoint = createAction(
  "editor/ADD_POINT",
  (point) => {
    return {
      payload: { point },
    };
  }
);

export const addRectangle = createAction(
  "editor/ADD_RECTANGLE",
  (rectangle) => {
    return {
      payload: { rectangle },
    };
  }
);

export const setCurrentPointerMode = createAction(
  "editor/CURRENT_POINTER_MODE",
  (mode) => {
    return {
      payload: { mode },
    };
  }
);

export const setActiveObjectId = createAction(
  "editor/SET_ACTIVE_OBJECT_ID",
  (id) => {
    return {
      payload: { id },
    };
  }
);

export const setActiveDetectedField = createAction(
  "editor/SET_ACTIVE_DETECTED_FIELD",
  (activeDetectedFieldId) => {
    return {
      payload: { activeDetectedFieldId },
    };
  }
);


export const changeRectangleFieldCoordinates = createAction(
  "editor/CHANGE_RECTANGLE_FIELD_COORDINATES",
  (id, x , y) => {
    return {
      payload: { id, x, y },
    };
  }
);

export const changeRectangleFieldSizes = createAction(
  "editor/CHANGE_RECTANGLE_FIELD_SIZES",
  (id, w , h) => {
    return {
      payload: { id, w, h },
    };
  }
);

export const setCurrentDrawingRectangle = createAction(
  "editor/SET_CURRENT_DRAWING_RECTANGLE",
  (data) => {
    return {
      payload: { data },
    };
  }
);

export const setDrawingObjectColor = createAction(
  "editor/SET_DRAWING_OBJECT_COLOR",
  (color) => {
    return {
      payload: { color },
    };
  }
);

export const setCurrentObjectColor = createAction(
  "editor/SET_CURRENT_OBJECT_COLOR",
  (color) => {
    return {
      payload: { color },
    };
  }
);

export const setDetectedFieldColor = createAction(
  "editor/SET_DETECTED_FIELD_COLOR",
  (color) => {
    return {
      payload: { color },
    };
  }
);

export const setObjectDefaultSizes = createAction(
  "editor/SET_OBJECT_DEFAULT_SIZES",
  (data) => {
    return {
      payload: { data },
    };
  }
);